/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { styles } from "../styles";
import { navLinks } from "./Contants";
import menu from '../assets/Images/menu.svg'
import close from '../assets/Images/close.svg'
import image from '../assets/Images/Logo2.png'

const Navbar = () => {
  const [active, setActive] = useState("");
  const [toggle, setToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`${
        styles.paddingX
      } w-full flex items-center py-5 fixed top-0 z-20 ${
        scrolled ? "bg-[#050518]" : "bg-transparent"
      }`}
    >
      <div className='w-full flex justify-between items-center max-w-7xl mx-auto'>
        <Link
          to='/'
          className='flex items-center gap-2'
          onClick={() => {
            setActive("");
            window.scrollTo(0, 0);
          }} 
        >
          <div className="logo custom-logo flex">
          <img src={image} alt='Logo' width={30}/>
            <h1 className="text-2xl p-1 text-white font-bold">Extrnl.io</h1>
          </div>
        </Link>
   
        <ul className='list-none hidden sm:flex flex-row gap-5 text-gray-400'>
          {navLinks.map((nav) => (            
            <li
              key={nav.id} 
              className={`${
                active === nav.title ? "text-gray-200" : "hover:text-white"
              } hover:text-white text-[18px] font-medium cursor-pointer`}
              onClick={() => setActive(nav.title)}
            >
              <a href={`/#${nav.id}`}>{nav.title}</a>
            </li>
            ))}
        </ul>

        <div className='sm:hidden flex flex-1 justify-end items-center'>
          <img 
            src={toggle ? close : menu}  
            alt={menu} 
            className='w-[28px] h-[28px] object-contain' 
            onClick={() => setToggle(!toggle)} 
          />

          <div
            className={`${
              !toggle ? "hidden" : "flex"
            } p-6 bg-zinc-800 opacity-80 absolute top-20 right-0 mx-4 my-2 min-w-[140px] z-10 rounded-xl`}
          >
            <ul className='list-none flex justify-end items-start flex-1 flex-col gap-2'>
              {navLinks.map((nav) => (
                <li
                  key={nav.id}
                  className={`font-poppins font-medium cursor-pointer text-white text-[16px] ${
                    active === nav.title ? "text-white" : "hover:text-white"
                  }`}
                  onClick={() => {
                    setToggle(!toggle);
                    setActive(nav.title);
                  }}
                >
                  <a href={`/#${nav.id}`}>{nav.title}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


